<script>
    export let titleText = "Processing...";
</script>

<div class="modal modal-open z-[1001] sm-modal-middle">
    <div class="modal-box relative">
        <div class="flex flex-1 justify-between">
            <h3 class="font-bold text-lg">{titleText}</h3>
        </div>
        <div class="flex mt-6 flex-1 justify-center">
            <progress class="progress progress-primary w-56" />
        </div>
    </div>
</div>
